import React from 'react';
import RicosViewer from '../../../ui/ricos-viewer/ricos-viewer';
import { getHeaderAndParagraphCustomStylesWUT, useRicosTheme } from '../../../theme/ricos-theme-utils';
import { getEventsHeaderContent } from '../utils';
const RICOS_THEME = {
  customStyles: getHeaderAndParagraphCustomStylesWUT()
};
export const EventsHeaderWUT = _ref => {
  let {
    goingContent,
    notGoingContent,
    waitlistContent,
    id,
    FieldLayout,
    externalData: {
      rsvpStatus
    }
  } = _ref;
  const customTheme = useRicosTheme(RICOS_THEME);
  const content = getEventsHeaderContent(rsvpStatus, goingContent, notGoingContent, waitlistContent);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(RicosViewer, {
    content: content,
    customTheme: customTheme
  }));
};
//# sourceMappingURL=events-header-wut.js.map